/**
 * Tower types grouped by the top a kit dresses (Towers v2, 2026-10-04: the skins dress all 12 towers).
 *  - ROOFED: the apex is a roof (on the cannon, ballista, fire and mortar a small back roof: the mortar's is its shell
 *    locker; the barracks' is its main ridge): a crown, an orrery, a fountain or a portal stands on it.
 *  - frost: no roof, the apex is the battlement's top with the crystal rising through it.
 *  - arcane: the apex is the gold collar under the FLOATING crystal, inside its orbiting rings — props there stay small
 *    and low (a circlet round the collar), or float above the crystal.
 *  - hex: the apex is the headdress bar under the feather crown, `top` the pole's top under the mask; the glowing eyes
 *    are on the mask's front — props ring the pole under the mask or float above the feathers.
 * Arcane and hex have slender shafts (wall/band r ≈ 0.13–0.26 against ≈ 0.3–0.4 on the others): wall props are fitted
 * smaller there (AttachmentUse.fit).
 */
export const ROOFED = ["archer", "cannon", "fire", "lightning", "ballista", "poison", "beacon", "mortar", "barracks"];
/** The slender towers (wall props fitted smaller). */
export const SLENDER = ["arcane", "hex"] as const;
